import React from "react";
import Draggable from "react-draggable";
import styled from "styled-components";

export const Corners = ({ cornerCoords, setCornerCoords, maxX, maxY }) => {
  const onCornerUpdate = (type, data) => {
    const { x, y } = data;
    const fracX = x / maxX;
    const fracY = y / maxY;

    const newData = { ...cornerCoords, [type]: [fracX, fracY] };

    setCornerCoords(newData);
  };

  const { topLeft, topRight, bottomLeft, bottomRight } = cornerCoords;

  return (
    <>
      <Draggable
        position={{ x: topLeft[0] * maxX, y: topLeft[1] * maxY }}
        bounds={{ left: 0, top: 0, right: maxX, bottom: maxY }}
        onStart={(e, data) => onCornerUpdate("topLeft", data)}
        onDrag={(e, data) => onCornerUpdate("topLeft", data)}
        onStop={(e, data) => onCornerUpdate("topLeft", data)}
      >
        <DragMarker style={{ background: "green" }} />
      </Draggable>

      <Draggable
        position={{ x: topRight[0] * maxX, y: topRight[1] * maxY }}
        bounds={{ left: 0, top: 0, right: maxX, bottom: maxY }}
        onStart={(e, data) => onCornerUpdate("topRight", data)}
        onDrag={(e, data) => onCornerUpdate("topRight", data)}
        onStop={(e, data) => onCornerUpdate("topRight", data)}
      >
        <DragMarker style={{ background: "red" }} />
      </Draggable>

      <Draggable
        position={{ x: bottomLeft[0] * maxX, y: bottomLeft[1] * maxY }}
        bounds={{ left: 0, top: 0, right: maxX, bottom: maxY }}
        onStart={(e, data) => onCornerUpdate("bottomLeft", data)}
        onDrag={(e, data) => onCornerUpdate("bottomLeft", data)}
        onStop={(e, data) => onCornerUpdate("bottomLeft", data)}
      >
        <DragMarker style={{ background: "blue" }} />
      </Draggable>

      <Draggable
        position={{ x: bottomRight[0] * maxX, y: bottomRight[1] * maxY }}
        bounds={{ left: 0, top: 0, right: maxX, bottom: maxY }}
        onStart={(e, data) => onCornerUpdate("bottomRight", data)}
        onDrag={(e, data) => onCornerUpdate("bottomRight", data)}
        onStop={(e, data) => onCornerUpdate("bottomRight", data)}
      >
        <DragMarker style={{ background: "yellow" }} />
      </Draggable>
    </>
  );
};

const DragMarker = styled.div`
  position: absolute;
  height: 30px;
  width: 30px;
  margin-left: -15px;
  margin-top: -15px;
  background: red;
  border-radius: 15px;
`;
